{
    "GenericFooter_ServerErrorTitle": "Validation errors",
    "GenericFooter_ValidationWarning": "Please ensure all fields are filled in correctly",
    "GenericFooter_ButtonHelpLabel": "Help?",
    "GenericFooter_ButtonSubmitLabel": "Save",
    "GenericFooter_ButtonCancelLabel": "Cancel",
    "NAME": "GenericFooter"
}